import styled from 'styled-components';

export const Base = styled.div<{ $width?: number }>`
	display: flex;
	align-items: center;
	min-width: 0;
	gap: 4px;
	${({ $width }) => $width && `width: ${$width}px; flex-shrink: 0;`}
`;
